import AllPodcastTable from './AllPodcastTable';

export default AllPodcastTable;
